$mynamespace_myapp_logo $mol_icon_molecule
